
import bgHeader from "../../assets/images/Newsletter/images/bg-header.png";
import July2023Banner from "../../assets/images/Newsletter/images/july2023.jpg";
import sagar from "../../assets/images/Newsletter/images/sagar.jpg";
import Bank from "../../assets/images/Newsletter/images/bank.jpg";
import DubaiMetro from "../../assets/images/Newsletter/images/Dubai-Metro.png";
import testimonials1 from "../../assets/images/Newsletter/images/testimonials1.jpg";
import testimonials2 from "../../assets/images/Newsletter/images/testimonials2.jpg";
import Impact from "../../assets/images/Newsletter/images/impact.jpg";
import News1 from "../../assets/images/Newsletter/images/news1.jpg";
import News2 from "../../assets/images/Newsletter/images/news2.jpg";
import News3 from "../../assets/images/Newsletter/images/news3.jpg";
import News4 from "../../assets/images/Newsletter/images/news4.jpg";
import Spiritualcorner from "../../assets/images/Newsletter/images/spiritual.jpg";
import event1 from "../../assets/images/Newsletter/images/event01.jpg";
import event2 from "../../assets/images/Newsletter/images/event02.jpg";
import event3 from "../../assets/images/Newsletter/images/event03.jpg";
import event4 from "../../assets/images/Newsletter/images/event04.jpg";
import Robert from "../../assets/images/Newsletter/images/robertc.png";
import CaseStudy from "../../assets/images/Newsletter/images/casestudy.jpg";
import Techtrends from "../../assets/images/Newsletter/images/techtrends.jpg";
import assospeak1 from "../../assets/images/Newsletter/images/assospeak1.jpg";
import assospeak2 from "../../assets/images/Newsletter/images/assospeak2.jpg";
import joinees from "../../assets/images/Newsletter/july-2023/welcome.jpg";
import city from "../../assets/images/Newsletter/images/city.png";
import fb1 from "../../assets/images/Newsletter/images/fb1.png";
import tw1 from "../../assets/images/Newsletter/images/tw1.png";
import ln1 from "../../assets/images/Newsletter/images/ln1.png";
import ig1 from "../../assets/images/Newsletter/images/ig1.png";
import yt1 from "../../assets/images/Newsletter/images/yt1.png";

const July2023 = () => {
  return (
    <>
      <>
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        {/*[if !mso]><!*/}
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        {/*<![endif]*/}
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <title>COMSENSE - NEWSLETTER June-2025</title>
        <link
          rel="shortcut icon"
          href="https://www.comsenseconsulting.com/images/ico/favicon.ico"
        />
        <style
          dangerouslySetInnerHTML={{
            __html:
              "\n    @import url(https://fonts.googleapis.com/css2?family=Cookie&display=swap);\n    @import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500&display=swap);\n\n    @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');\n\n    @font-face {\n      font-family: 'Century Gothic', sans-serif;\n      src: url(fonts/CenturyGothic.ttf);\n    }\n\n    html {\n      font-family: century-gothic, sans-serif;\n      font-family: \"Montserrat\", sans-serif;\n    }\n\n    .ReadMsgBody {\n      width: 100%;\n      background-color: #fff\n    }\n\n    .ExternalClass {\n      width: 100%;\n      background-color: #fff\n    }\n\n    .ExternalClass,\n    .ExternalClass div,\n    .ExternalClass font,\n    .ExternalClass p,\n    .ExternalClass span,\n    .ExternalClass td {\n      line-height: 100%\n    }\n\n    html {\n      width: 100%\n    }\n\n    body {\n      -webkit-text-size-adjust: none;\n      -ms-text-size-adjust: none;\n      margin: 0;\n      padding: 0;\n      font-family: 'Open Sans', Arial, Sans-serif !important;\n      font-family: \"Montserrat\", sans-serif !important;\n    }\n\n    table {\n      border-spacing: 0;\n      table-layout: fixed;\n      margin: 0 auto\n    }\n\n    table table table {\n      table-layout: auto\n    }\n\n    img {\n      display: block !important;\n      overflow: hidden !important\n    }\n\n    .yshortcuts a {\n      border-bottom: none !important\n    }\n\n    img:hover {\n      opacity: .9 !important\n    }\n\n    a {\n      color: red;\n      text-decoration: none\n    }\n\n    .textbutton a {\n      font-family: 'open sans', arial, sans-serif !important;\n      font-family: \"Montserrat\", sans-serif;\n    }\n\n    .btn-link a {\n      color: #fff !important\n    }\n\n    ul {\n      padding-inline-start: 20px\n    }\n\n    ol {\n      padding-inline-start: 20px\n    }\n\n    .mobile-responsive {\n      display: none\n    }\n\n    .image-reponsive {\n      float: left;\n      margin-left: 0;\n      margin-right: 25px;\n      margin-top: 10px\n    }\n\n    @media only screen and (max-width:640px) {\n      body {\n        margin: 0;\n        width: auto !important;\n        font-family: 'Open Sans', Arial, Sans-serif !important\n      }\n\n      .table-inner {\n        width: 90% !important;\n        max-width: 90% !important\n      }\n\n      .table-full {\n        width: 100% !important;\n        max-width: 100% !important;\n        text-align: center !important\n      }\n\n      #sagar img {\n        width: 50%\n      }\n\n      .mobile-responsive {\n        display: block\n      }\n\n      .desktop-view {\n        display: none\n      }\n\n      .image-reponsive {\n        float: unset;\n        margin: 0 auto 10px\n      }\n\n      @media only screen and (max-width:479px) {\n        body {\n          width: auto !important;\n          font-family: 'Open Sans', Arial, Sans-serif !important\n        }\n\n        .table-inner {\n          width: 90% !important;\n          text-align: center !important\n        }\n\n        .table-full {\n          width: 100% !important;\n          max-width: 100% !important;\n          text-align: center !important\n        }\n\n        u+.body .full {\n          width: 100% !important;\n          width: 100vw !important\n        }\n\n        #sagar img {\n          width: 50%\n        }\n      }\n    }\n  ",
          }}
        />
        <table
          className="full newsletter-emailer"
          width="100%"
          alignitems="center"
          cellSpacing={0}
          cellPadding={0}
        >
          <tbody>
            <tr>
              <td
                bgcolor="#333742"
                background={bgHeader}
                style={{
                  borderTop: "4px solid red",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
                align="center"
              >
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td
                        height={40}
                        valign="top"
                        style={{
                          fontFamily: "Open sans,arial,sans-serif",
                          fontSize: 10,
                          color: "#fff",
                          lineHeight: "24px",
                          textAlign: "center",
                        }}
                      >
                        If this newsletter is not displayed correctly, please{" "}
                        <a href="/" style={{ color: "#fff" }}>
                          <u>click here</u>
                        </a>
                        .
                      </td>
                    </tr>
                    {/* <tr>
                      <td align="center">
                        <table
                          className="table-full"
                          align="centre"
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                        >
                          <tbody>
                            <tr>
                              <td align="center" style={{ lineHeight: 0 }}>
                                <img
                                  editable=""
                                  label="image"
                                  style={{
                                    display: "block",
                                    lineHeight: 0,
                                    fontSize: 0,
                                    border: 0,
                                  }}
                                  src={logo}
                                  width={160}
                                  alt="logo"
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr> */}
                    {/* <tr>
                      <td height={25} />
                    </tr> */}
                  </tbody>
                </table>
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td>
                        <img
                          editable=""
                          label="image"
                          style={{
                            display: "block",
                            lineHeight: 0,
                            fontSize: 0,
                            border: 0,
                          }}
                          src={July2023Banner}
                          width="100%"
                          alt="logo"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        <repeater>
          <table
            className="full"
            align="center"
            bgcolor="#333742"
            width="100%"
            border={0}
            cellSpacing={0}
            cellPadding={0}
          >
            <tbody>
              <tr>
                <td align="center">
                  <table
                    className="table-full"
                    width={600}
                    style={{ maxWidth: 600 }}
                    border={0}
                    align="center"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <tbody>
                      <tr>
                        <td bgcolor="#FFFFFF" align="center">
                          <table
                            className="table-inner"
                            width={550}
                            border={0}
                            align="center"
                            cellPadding={0}
                            cellSpacing={0}
                          >
                            <tbody>
                              <tr>
                                <td height={20} />
                              </tr>
                              <tr>
                                <td height={20} />
                              </tr>
                              <tr>
                                <td>
                                  <table
                                    width={150}
                                    className="table-full"
                                    border={0}
                                    align="left"
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          id="sagar"
                                          align="center"
                                          style={{ lineHeight: 0 }}
                                        >
                                          <img
                                            src={sagar}
                                            alt="icon"
                                            style={{
                                              display: "block",
                                              lineHeight: 0,
                                              fontSize: 0,
                                              border: 0,
                                              width: 167,
                                            }}
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  {/*[if (gte mso 9)|(IE)]>
                </td>
                <td>
                  <![endif]*/}
                                  <table
                                    width={25}
                                    align="left"
                                    border={0}
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td height={15} />
                                      </tr>
                                    </tbody>
                                  </table>
                                  {/*[if (gte mso 9)|(IE)]>
                </td>
                <td>
                  <![endif]*/}
                                  <table
                                    className="table-full"
                                    width={375}
                                    border={0}
                                    align="right"
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td height={90} />
                                      </tr>
                                      <tr>
                                        <td
                                          align="center"
                                          style={{
                                            border: "0 solid #fff",
                                            borderRadius: 4,
                                          }}
                                        >
                                          <table
                                            width="90%"
                                            border={0}
                                            align="center"
                                            cellPadding={0}
                                            cellSpacing={0}
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  valign="bottom"
                                                  style={{
                                                    fontFamily:
                                                      "Century gothic,arial,sans-serif",
                                                    fontSize: 24,
                                                    color: "#4a4a4a",
                                                    fontWeight: 100,
                                                    lineHeight: "30px",
                                                  }}
                                                >
                                                  From the CEO’s Desk
                                                </td>
                                              </tr>
                                              <tr>
                                                <td height={10} />
                                              </tr>
                                              <tr>
                                                <td align="left">
                                                  <table
                                                    align="left"
                                                    width={30}
                                                    border={0}
                                                    cellSpacing={0}
                                                    cellPadding={0}
                                                  >
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          height={10}
                                                          style={{
                                                            borderBottom:
                                                              "3px solid red",
                                                          }}
                                                        />
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td height={20} />
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td height={20} />
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "24px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Dear Friends,
                                              <br />
                                              <br />
                                              It is with a blend of enthusiasm
                                              and realism that I bring forth this
                                              edition of our quarterly newsletter.
                                              As we navigate through economically
                                              challenging times across the globe,
                                              I am still filled with hope, renewed
                                              enthusiasm, and an unwavering sense
                                              of optimism.
                                              <br />
                                              <br />
                                              The adverse effect of the slowdown
                                              in the US and Europe has impacted
                                              us too. We have experienced tightened
                                              budgets, decreased customer spending,
                                              and an overall delay in closing deals.
                                              While this has impacted our business,
                                              we have been demonstrating remarkable
                                              adaptability, finding innovative
                                              solutions, and identifying newer
                                              avenues for growth in adverse times.
                                              <br />
                                              <br />
                                              For the upcoming quarters, we intend
                                              to grow our existing accounts and
                                              invest more in account managers.
                                              <br />
                                              <br />
                                              As Innovation is a crucial pillar of
                                              Comsense’s success, we intend to
                                              improve our focus on the same. We are
                                              consistently building an innovative
                                              culture within our workspaces to
                                              offer improved value to customers.
                                              <br />
                                              <br />
                                              In line with our belief in innovation,
                                              we are preparing to launch a new
                                              product ‘Find Your Best Customer’.
                                              This specialized offering is being
                                              developed at our Innovation Hub for
                                              our retail clients. We should be able
                                              to successfully launch it this year.
                                              <br />
                                              <br />
                                              Lastly, I am glad to announce that
                                              we are planning to set up dedicated
                                              sales teams in Mumbai and Gurgaon,
                                              which will help us increase our
                                              reach within our country.
                                              <br />
                                              <br />
                                              With that, I leave you to read the
                                              newsletter and witness our resilience,
                                              collective effort, and indomitable
                                              spirit towards the brighter future
                                              of our company.
                                              <br />
                                              <br />
                                              Wishing you all a great quarter ahead!
                                              <br />
                                              <br />
                                              <strong>Sagar Babar</strong>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Won Deals
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  Comsense Wins a Deal from Dubai Metro
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={DubaiMetro}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Comsense recently won a deal from
                                                Dubai Metro where we would provide
                                                insights on live metro data. We will
                                                be transforming this data into
                                                intuitive apps and dashboards. We
                                                would also be building a support
                                                application using Mendix- a low
                                                code, no code technology.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>

                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  <strong>

                                                    Comsense Won a Deal from A Leading Bank in Dubai
                                                  </strong>
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={
                                                Bank
                                              }
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                A leading bank in Dubai awarded Comsense a project to manage its AML(Anti-Money Laundering) program. Comsense will also ensure SME digital onboarding as a part of the project.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          {/* <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  We Are Thrilled to Collaborate
                                                  with a Leading Real Estate
                                                  Company to Implement
                                                  Salesforce Data Cloud
                                                </strong>
                                              </p>
                                            </multiline>
                                          </td> */}
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Testimonials
                                            </singleline>
                                          </td>

                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            {/* <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={RealEstateCompany2}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            /> */}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <img
                                                style={{
                                                  display: "block",
                                                  lineHeight: 0,
                                                  fontSize: 0,
                                                  border: 0,
                                                  width: "100%",
                                                }}
                                                src={testimonials1}
                                                alt="Testimonial"
                                                width="100%"
                                                height="auto"
                                              />
                                              <br />
                                              <img
                                                style={{
                                                  display: "block",
                                                  lineHeight: 0,
                                                  fontSize: 0,
                                                  border: 0,
                                                  width: "100%",
                                                }}
                                                src={testimonials2}
                                                alt="Testimonial"
                                                width="100%"
                                                height="auto"
                                              />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>

                                        <tr>
                                          <td align="center">
                                            <multiline label="content">
                                              <table
                                                width="100%"
                                                align="center"
                                                border={0}
                                                cellSpacing={0}
                                                cellPadding={0}
                                                style={{
                                                  border: "1px solid #d9d9d9",
                                                }}
                                              >
                                                <tbody>
                                                  <tr>

                                                    <td
                                                      style={{
                                                        padding: "22px 20px",
                                                        fontFamily:
                                                          "Open sans,arial,sans-serif",
                                                        color: "#9b9b9b",
                                                        lineHeight: "28px",
                                                        fontSize: 18,
                                                        fontStyle: "italic",
                                                      }}
                                                      valign="top"

                                                    >


                                                      “Success is to be measured
                                                      not so much by the position
                                                      that one has reached in life
                                                      as by the obstacles which he
                                                      has overcome.”
                                                      <br />
                                                      <br />
                                                      <span
                                                        style={{
                                                          fontStyle: "normal",
                                                          fontWeight: 700,
                                                          color: "#4a4a4a",
                                                          fontSize: 20,
                                                        }}
                                                      >
                                                        - Booker T. Washington,
                                                      </span>
                                                      <br />
                                                      <span
                                                        style={{
                                                          fontStyle: "normal",
                                                          fontWeight: 600,
                                                          color: "#9b9b9b",
                                                          fontSize: 18,
                                                        }}
                                                      >
                                                        American Author, Educator,
                                                        and Advisor
                                                      </span>
                                                    </td>

                                                  </tr>
                                                </tbody>
                                              </table>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              News
                                            </singleline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={20} />
                                        </tr>

                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: "0px",
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "#FF0000",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Comsense Launches Monthly Delivery
                                            Newsletter For Clients
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={
                                                News1
                                              }
                                              alt="News"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                We love to keep our customers
                                                informed! To have a successful
                                                collaborative journey, Comsense
                                                recently rolled out its inaugural
                                                monthly delivery newsletter for
                                                one of our clients, Redington. The
                                                newsletter includes key delivery
                                                highlights for each month, the
                                                results of our efforts and
                                                campaigns that we run, and the way
                                                forward for the next month. We
                                                will be rolling out a similar
                                                delivery newsletter for all our
                                                clients to enable them to
                                                effectively target their campaigns
                                                based on the insights provided.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  A Snapshot of Our Internal Tech
                                                  Delivery Newsletter
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={
                                                Impact
                                              }
                                              alt="Impact newsletter snapshot"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Impact – Our Internal Delivery
                                                Newsletter launched last quarter is
                                                a comprehensive resource for all
                                                team members. It provides a snapshot
                                                of new and ongoing projects,
                                                successfully delivered projects,
                                                and Work in Progress deals. Take a
                                                quick look at the snapshot of
                                                campaigns and assets from the
                                                previous quarter.
                                              </p>
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  Innovating And Letting All Know
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={
                                                News2
                                              }
                                              alt="Innovation newsletter"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Comsense has recently started a
                                                new quarterly internal Innovation
                                                Newsletter. The newsletter covers
                                                our innovative solutions and
                                                endeavors within Comsense and
                                                with its partners. It is aimed at
                                                inculcating an innovative culture
                                                within the company. It also
                                                encourages team members across
                                                the organization to come up with
                                                innovative ideas in their work
                                                area or for the organization
                                                overall.
                                              </p>
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "#FF0000",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Comsense Prepares For The Launch Of
                                            Their New Product ‘Find Your Best
                                            Customer’
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={News3}
                                              alt="Find Your Best Customer"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Innovation and Customer
                                                Experience hold an important place
                                                in our growth journey. Thus, our
                                                team relentlessly works at
                                                creating solutions that add value.
                                                Team Comsense has been working for
                                                a while on creating and launching
                                                our new product, ‘Find your Best
                                                Customer’. The solution, which is
                                                almost in its final stages of
                                                development, aims at channelizing
                                                raw data to provide segmented
                                                customer insights leading to
                                                successful personalization. It
                                                will officially be launched soon,
                                                and we are optimistic that it will
                                                take our customers’ businesses to
                                                newer heights by helping them
                                                target their best customers.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={30} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "#FF0000",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Comsense Brings Consumable
                                            Intelligence on Personalized
                                            Dashboards using IntellSense
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={News4}
                                              alt="IntellSense dashboards"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                At Comsense, it is our constant
                                                endeavor to deliver the ultimate
                                                experience and improvise
                                                efficiency. As a step towards
                                                making Consumable Insights
                                                available at a snap of a finger
                                                via personalized dashboards, we
                                                have built a new solution -
                                                IntellSense - an AI-driven,
                                                self-service business intelligence
                                                and reporting tool (BIRT). Using
                                                this solution, users get a one
                                                data view and can easily create
                                                dashboards with a pre-built KPI
                                                library to better visualize their
                                                data.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <br />
                                    <br />
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Case Study
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={CaseStudy}
                                              alt="Case study"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Tech Trends
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={
                                                Techtrends
                                              }
                                              alt="Tech Trends"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                In recent years, MarTech has
                                                experienced significant growth and
                                                evolution. It has expanded from
                                                basic email marketing software to
                                                encompass technologies such as data
                                                analytics, AI, CRM systems, and
                                                social media management. The
                                                abundance of digital touchpoints
                                                and customer data has facilitated
                                                targeted and personalized
                                                experiences. MarTech also
                                                automates tasks, freeing up time
                                                for strategic initiatives, and
                                                plays a vital role in measuring
                                                marketing effectiveness and
                                                attributing ROI through advanced
                                                analytics. Integration and
                                                interoperability are now crucial as
                                                businesses seek comprehensive
                                                MarTech stacks.
                                                <br />
                                                <br />
                                                In 2021, the industry received
                                                $39.8B in investment, with notable
                                                categories including web
                                                performance, security, training,
                                                retail eCommerce, analytics, and
                                                productivity. In 2022, the
                                                investment totalled $28.4B, with
                                                categories like web performance,
                                                security, payments, productivity,
                                                and advertising leading the way.
                                                Despite a downturn due to economic
                                                uncertainty, these investments
                                                highlight the importance of
                                                various MarTech segments and
                                                emerging areas like blockchain and
                                                customer experience.
                                                <br />
                                                <br />
                                                <strong>Outlook in 2023 and Beyond</strong>
                                                <br />
                                                <br />
                                                As we delve into 2023, it becomes
                                                evident that the MarTech landscape
                                                is undergoing rapid transformation.
                                                The convergence of new
                                                technologies, evolving consumer
                                                behaviours, and heightened
                                                competition compels marketers to
                                                embrace innovation and creativity
                                                on unprecedented levels.
                                              </p>

                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                <strong>
                                                  Increased adoption of AI and machine
                                                  learning:
                                                </strong>{" "}
                                                AI and machine learning technologies
                                                have recently shaped and will
                                                continue to shape the MarTech
                                                landscape. Marketers will leverage
                                                these technologies for advanced data
                                                analysis, predictive analytics,
                                                personalization, and automation,
                                                allowing for more efficient and
                                                targeted campaigns.
                                              </p>
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                <strong>
                                                  Enhanced customer experience focus:
                                                </strong>{" "}
                                                MarTech will increasingly prioritize
                                                delivering exceptional customer
                                                experiences. Marketers will leverage
                                                data-driven insights to create
                                                personalized and relevant
                                                experiences across multiple
                                                touchpoints throughout the customer
                                                journey.
                                              </p>
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                <strong>
                                                  Privacy and data regulations:
                                                </strong>{" "}
                                                With the rise in data privacy
                                                concerns and regulatory frameworks,
                                                such as GDPR and CCPA, MarTech will
                                                adapt to ensure compliance and data
                                                security. Marketers will invest in
                                                technologies that prioritize data
                                                protection, consent management, and
                                                transparency to build consumer
                                                trust.
                                              </p>
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                <strong>
                                                  Integration and interoperability:
                                                </strong>{" "}
                                                The trend of integrating various
                                                MarTech tools and platforms will
                                                continue to gain momentum.
                                                Businesses will seek solutions that
                                                seamlessly integrate and share data,
                                                enabling a holistic view of
                                                customer interactions and improved
                                                collaboration across marketing
                                                teams.
                                              </p>
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                <strong>
                                                  Agile marketing and real-time analytics:
                                                </strong>{" "}
                                                MarTech will support agile marketing
                                                strategies, allowing marketers to
                                                quickly adapt and respond to
                                                changing market dynamics. Real-time
                                                analytics and reporting capabilities
                                                will enable data-driven
                                                decision-making, empowering
                                                marketers to optimize campaigns and
                                                allocate resources effectively.
                                              </p>
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                In conclusion, the MarTech landscape
                                                continues to evolve and flourish,
                                                presenting marketers with an exciting
                                                realm of possibilities. With the
                                                integration of advanced
                                                technologies, data-driven insights,
                                                and a customer-centric approach,
                                                MarTech empowers businesses to
                                                connect with their target audiences
                                                on a deeper level, deliver
                                                personalized experiences, and
                                                achieve remarkable results.
                                              </p>
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width="100%"
                                              align="center"
                                              border={0}
                                              cellSpacing={0}
                                              cellPadding={0}
                                              style={{
                                                border: "2px solid #d2d2d2",
                                              }}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    style={{
                                                      padding: "18px 16px",
                                                      fontFamily:
                                                        "Open sans,arial,sans-serif",
                                                      fontSize: 14,
                                                      color: "#9b9b9b",
                                                      lineHeight: "22px",
                                                      fontStyle: "italic",
                                                      textAlign: "left",
                                                    }}
                                                    valign="top"
                                                  >
                                                    “Success is the sum of small
                                                    efforts, repeated day in and
                                                    day out”
                                                    <br />
                                                    <br />
                                                    <span
                                                      style={{
                                                        fontStyle: "normal",
                                                        fontWeight: 700,
                                                        color: "#4a4a4a",
                                                      }}
                                                    >
                                                      - Robert Collier,
                                                    </span>{" "}
                                                    <span
                                                      style={{
                                                        fontStyle: "normal",
                                                        fontWeight: 600,
                                                        color: "#9b9b9b",
                                                      }}
                                                    >
                                                      American Author
                                                    </span>
                                                  </td>
                                                  <td
                                                    width={140}
                                                    align="center"
                                                    valign="top"
                                                    style={{
                                                      padding: "18px 16px",
                                                      lineHeight: 0,
                                                    }}
                                                  >
                                                    <img
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                      }}
                                                      src={
                                                        Robert
                                                      }
                                                      alt="Robert Collier"
                                                      width={110}
                                                      height="auto"
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={30} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Associates Speak
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={assospeak1}
                                              alt="Associates Speak"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={assospeak2}
                                              alt="Associates Speak"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/*     <layout label=quote>
<table class=full bgcolor=#333742 align=center width=100% border=0 cellspacing=0 cellpadding=0>
  <tr>
    <td align=center>
      <table class=table-full width=600 style=max-width:600px border=0 align=center cellpadding=0 cellspacing=0>
        <tr>
          <td bgcolor=#FFFFFF align=center>
            <table class=table-inner width=550 style=max-width:550px border=0 align=center cellpadding=0
              cellspacing=0>

              <tr>
                <td height=25></td>
              </tr>
              <tr>
                <td height=25></td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>
    </layout> */}
          {/* <layout label="1/1 content">
<table class=full bgcolor=#333742 align=center width=100% border=0 cellspacing=0 cellpadding=0>
  <tbody>
    <tr>
      <td align=center>
        <table align=center border=0 cellpadding=0 cellspacing=0>
          <tbody>
            <tr>
              <td width=600 align=center>
                <table class=table-full width=100% align=center border=0 cellpadding=0 cellspacing=0>
                  <tbody>
                    <tr>
                      <td bgcolor=#FFFFFF align=center style=text-align:center;vertical-align:top;font-size:0>
                        <table align=center width=90% border=0 cellspacing=0 cellpadding=0>
                          <tbody>
                            <tr>
                              <td height=25></td>
                            </tr>
                            <tr>
                              <td align=center width=580
                                style="font-family:Century gothic,arial,sans-serif;font-size:24px;color:#4a4a4a;font-weight:100;line-height:30px">
                                <singleline label=title>Case Studies </singleline>
                              </td>
                            </tr>
                            <tr>
                              <td height=20></td>
                            </tr>
                            <tr>
                              <td align=center>
                                <table width=40 bgcolor=#FF0000 style=border-radius:10px border=0 cellpadding=0
                                  cellspacing=0>
                                  <tbody>
                                    <tr>
                                      <td height=5 style=line-height:0;font-size:0px>&nbsp;</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <br>
                            <tr>
                              <td height=20></td>
                            </tr>
                            <tr>
                              <td width=580 align=center
                                style="font-family:Open sans,arial,sans-serif;font-size:18px;color:red;line-height:28px;font-weight:700;text-align:center">
                                Comsense Quarterly Awards
                              </td>
                            </tr>
                            <tr>
                              <td height=25></td>
                            </tr>
                            <tr>
                              <td width=580 align=center style=line-height:0>
                                <img style=display:block;line-height:0;font-size:0px;border:0;width:100%
                                  src=images/awards.png alt=img width=100% height=auto>
                              </td>
                            </tr>
                            <tr>
                              <td height=10></td>
                            </tr>
                            <tr>
                              <td height=25></td>
                            </tr>
                            <tr>
                              <td align=center
                                style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                                <multiline label=content>Since we were unable to organize our Quarterly Award
                                  Ceremony in our previous quarter, we made it up by awarding people from two
                                  previous quarters together.<br></multiline>
                              </td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td align=left
                                style="font-family:Open sans,arial,sans-serif;font-size:16px;color:red;line-height:28px;font-weight:700;text-align:left">
                                Rookie (Rising Star) Award:
                              </td>
                            </tr>
                            <tr>
                              <td align=center
                                style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                                <multiline label=content>Comsense is always proud of its young and fresh team
                                  members who excel very early in their careers. This time our Rising star awards
                                  were given to <strong>Abhishek Sontakke, Sneha Kshirsagar, and Girish
                                    Sahare</strong> for their excellent performances in such early days of their
                                  span at Comsense.<br></multiline>
                              </td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td align=left
                                style="font-family:Open sans,arial,sans-serif;font-size:16px;color:red;line-height:28px;font-weight:700;text-align:left">
                                Star Performer Award:
                              </td>
                            </tr>
                            <tr>
                              <td align=center
                                style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                                <multiline label=content>Our best performers of the last two quarters were
                                  <strong>Anant Kadam, Shubham Chordia, and Soumy Dubey.</strong> They have gone
                                  beyond their roles to ensure Comsense’s success and thus rightly deserve the
                                  award. <br></multiline>
                              </td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td align=left
                                style="font-family:Open sans,arial,sans-serif;font-size:16px;color:red;line-height:28px;font-weight:700;text-align:left">
                                Ace Contributors:
                              </td>
                            </tr>
                            <tr>
                              <td align=center
                                style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                                <multiline label=content><strong>Rakhi Ankar</strong> was awarded the Ace
                                  Contributor award for being excellent in all roles and responsibilities given to
                                  her.<br></multiline>
                              </td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td align=left
                                style="font-family:Open sans,arial,sans-serif;font-size:16px;color:red;line-height:28px;font-weight:700;text-align:left">
                                Innovation Award:
                              </td>
                            </tr>
                            <tr>
                              <td align=center
                                style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                                <multiline label=content><strong>Suvaknata Rawat</strong> was awarded the
                                  innovation award for showcasing an excellent innovative approach towards problem
                                  solving and solutioning. <br></multiline>
                              </td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td height=25></td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
    </layout> */}
          <layout label="1/1 content">
            {/* <table class=full bgcolor=#333742 align=center width=100% border=0 cellspacing=0 cellpadding=0>
  <tr>
    <td align=center>
      <table align=center border=0 cellpadding=0 cellspacing=0>
        <tr>
          <td width=600 align=center>
            <table class=table-full width=100% align=center border=0 cellpadding=0 cellspacing=0>
              <tr>
                <td bgcolor=#FFFFFF align=center style=text-align:center;vertical-align:top;font-size:0>
                  <table align=center width=90% border=0 cellspacing=0 cellpadding=0>
                    <tr>
                      <td height=25></td>
                    </tr>
                    <tr>
                      <td width=580 align=center style=line-height:0>
                        <img style=display:block;line-height:0;font-size:0px;border:0;width:100%
                          src=images/five-years.png alt=img width=100% height=auto>
                      </td>
                    </tr>
                    <tr>
                      <td height=25></td>
                    </tr>
                    <tr>
                      <td align=center
                        style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                        <multiline label=content>
                          We were thrilled to honor Vishnu Kamath and Neerajkumar Gogavale with the Long Service
                          Award as they both completed 5 years with Comsense. We are thankful for their faith and
                          belief in the spirit of Comsense and wish them a long, fruitful journey ahead with us!
                          <br><br>
                        </multiline>
                      </td>
                    </tr>
                    <tr>
                      <td height=25></td>
                    </tr>
                    <tr>
                      <td height=20></td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table> */}
          </layout>
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                              textAlign: "center",
                                            }}
                                          >
                                            <singleline label="title">
                                              Associates Learn
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{
                                                borderRadius: 10,
                                                margin: "0 auto",
                                              }}
                                              border={0}
                                              align="center"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Our never-ending quest for
                                                knowledge has helped us build a
                                                robust learning environment for
                                                our associates. Every team member
                                                is encouraged to upskill
                                                themselves each year and be
                                                abreast with the latest
                                                technologies and trends.
                                                <br />
                                                <br />
                                                In the last quarter, many of our
                                                team members completed various
                                                certification programs. The top
                                                learners of the quarter were:
                                              </p>
                                              <div
                                                style={{
                                                  marginTop: 16,
                                                  border: "1px solid #666",
                                                  padding: "12px 14px",
                                                  fontFamily:
                                                    "Open sans,arial,sans-serif",
                                                  fontSize: 14,
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "left",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "grid",
                                                    gridTemplateColumns: "1fr 1fr",
                                                    gap: 8,
                                                    fontWeight: 700,
                                                    paddingBottom: 8,
                                                    marginBottom: 8,
                                                    borderBottom: "1px solid #666",
                                                  }}
                                                >
                                                  <span>Certifications</span>
                                                  <span>Associate Names</span>
                                                </div>
                                                <div
                                                  style={{
                                                    display: "grid",
                                                    gridTemplateColumns: "1fr 1fr",
                                                    gap: 8,
                                                    marginBottom: 12,
                                                  }}
                                                >
                                                  <div>Chat GPT 101 – B18</div>
                                                  <div>Sushant Pingale</div>
                                                </div>
                                                <div
                                                  style={{
                                                    display: "grid",
                                                    gridTemplateColumns: "1fr 1fr",
                                                    gap: 8,
                                                    marginBottom: 12,
                                                  }}
                                                >
                                                  <div>
                                                    IBM’s Cognos Analytics with
                                                    Watson
                                                  </div>
                                                  <div>
                                                    Varada Pol
                                                    <br />
                                                    Sumedh Pawaskar
                                                    <br />
                                                    Nishchal Jinturkar
                                                  </div>
                                                </div>
                                                <div
                                                  style={{
                                                    display: "grid",
                                                    gridTemplateColumns: "1fr 1fr",
                                                    gap: 8,
                                                  }}
                                                >
                                                  <div>Google Analytics</div>
                                                  <div>
                                                    Dipali More
                                                    <br />
                                                    Shivkumar Dusad
                                                    <br />
                                                    Tushar Rane
                                                  </div>
                                                </div>
                                              </div>
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                  marginTop: 16,
                                                }}
                                              >
                                                We send our heartiest
                                                congratulations to each one of
                                                them!
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={40} />
                                        </tr>

                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                              textAlign: "center",
                                            }}
                                          >
                                            <singleline label="title">
                                              Welcome Aboard
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{
                                                borderRadius: 10,
                                                margin: "0 auto",
                                              }}
                                              border={0}
                                              align="center"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={joinees}
                                              alt="Welcome aboard"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                No challenge is too big for
                                                Comsense. Despite a mild business
                                                slowdown, we proudly announce
                                                that we are growing
                                                quarter-on-quarter in numbers.
                                                <br />
                                                <br />
                                                <strong>
                                                  Shipra Shaurya, Kiran Bokde,
                                                  Vijaya Biradar, Rajat Suna,
                                                  Ajay Chimpanpure, and
                                                  Suvakanta Rout
                                                </strong>{" "}
                                                joined our amazing team in the
                                                last quarter.
                                                <br />
                                                <br />
                                                We also had a few interns join
                                                us in this quarter.{" "}
                                                <strong>
                                                  Srushti Sonkar, Hardik
                                                  Khandagale, Aakash Nair, Aadra
                                                  Nair, Sejal Gujarathi, and
                                                  Yugant Kawade
                                                </strong>{" "}
                                                joined our super successful
                                                internship program.
                                                <br />
                                                <br />
                                                We wish them all a great career
                                                ahead!
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/* Events & Celebrations */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                              textAlign: "center",
                                            }}
                                          >
                                            <singleline label="title">
                                              Events and Celebrations
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{
                                                borderRadius: 10,
                                                margin: "0 auto",
                                              }}
                                              border={0}
                                              align="center"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Team Comsense Participated in The CX
                                            Innovation and Technology Summit and
                                            Awards 2023
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={event2}
                                              alt="CX Innovation and Technology Summit"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "center",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                Our team was thrilled to
                                                participate in the CX Innovation
                                                and Technology Summit and Awards
                                                2023. Our Co-founder, Biju
                                                Nambiar, mesmerized the audience
                                                with his presentation on
                                                ‘Discovering the best customer’.
                                                He talked about how it’s not just
                                                your customers that are running
                                                your business but your best
                                                customers who are doing it.
                                                <br />
                                                <br />
                                                <span
                                                  style={{
                                                    fontFamily:
                                                      "Open sans,arial,sans-serif",
                                                    fontSize: 14,
                                                    color: "#FF0000",
                                                    paddingRight: 15,
                                                  }}
                                                >
                                                  <a
                                                    href="https://www.youtube.com/watch?v=HjbKUWXIwJs"
                                                    style={{
                                                      textDecoration: "none",
                                                      color: "#FF0000",
                                                    }}
                                                    target="_blank"
                                                    rel="noreferrer noopener"
                                                  >
                                                    Watch his thought-provoking
                                                    presentation here &rsaquo;
                                                  </a>
                                                </span>
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={35} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            5000 & Going!!!! Yaaay!!!
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={
                                                event1
                                              }
                                              alt="5000 LinkedIn followers"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "center",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                Comsense was thrilled to reach a
                                                milestone figure of 5000 followers
                                                on LinkedIn a few weeks ago. As
                                                this Newsletter goes live, we are
                                                all the more excited as we have
                                                already crossed the 6000 followers
                                                mark! A huge thanks to everyone
                                                for their interest, continued
                                                followership, and engagement with
                                                our organization. We endeavor to
                                                help, to be interesting, and
                                                ultimately to be useful with the
                                                content we share with you.
                                                <br />
                                                <br />
                                                <span
                                                  style={{
                                                    fontFamily:
                                                      "Open sans,arial,sans-serif",
                                                    fontSize: 14,
                                                    color: "#FF0000",
                                                    paddingRight: 15,
                                                  }}
                                                >
                                                  <a
                                                    href="https://www.linkedin.com/posts/comsense-consulting_comsense-linkedin-grateful-activity-7072458135382241282-cFhl/?utm_source=share&utm_medium=member_desktop"
                                                    style={{
                                                      textDecoration: "none",
                                                      color: "#FF0000",
                                                    }}
                                                    target="_blank"
                                                    rel="noreferrer noopener"
                                                  >
                                                    Read More &rsaquo;
                                                  </a>
                                                </span>
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Birthday Celebrations
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={
                                                event4
                                              }
                                              alt="Team birthday celebration"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "center",
                                            }}
                                          >
                                            <multiline label="content">
                                              The previous quarter was full of
                                              birthday celebrations. We just
                                              realized how Team Comsense is
                                              heavy with Summer Borns!
                                              <br />
                                              <br />
                                              In April, we celebrated the
                                              birthdays of Tejaswi Raje, Rutika
                                              Bhikule, Sayali Shewale, Shraddha
                                              Kale, Ashwini Ghorpade, Anant
                                              Kadam, Swapnali Anarase, Rishabh
                                              Manchanda, Shipra Shaurya, and
                                              Kiran Bokde.
                                              <br />
                                              <br />
                                              May was the birthday month for
                                              Uddhav Solanke, Sumedh Pawaskar,
                                              Madhuri Sawant, Varada Pol, Tushar
                                              Valkunde, Ranjith Rajmohan,
                                              Shivkumar Dusad, Shobhit Patodia,
                                              Shubham Chordia, and Yogeshwar
                                              Nalabale.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            A Special Birthday!
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={
                                                event3
                                              }
                                              alt="Aniket Neurgaonkar birthday"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "center",
                                            }}
                                          >
                                            <multiline label="content">
                                              June became extra special for us
                                              as we celebrated the birthday of
                                              our Co-founder, Aniket Neurgaonkar.
                                              The day was celebrated with a
                                              special cake-cutting ceremony for
                                              him. Everyone gathered around to
                                              celebrate not just his special day
                                              but his charismatic and witty self
                                              that keeps the spirit of Comsense
                                              alive! Wishing him a fabulous year
                                              ahead!
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Spiritual Corner
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height="30"></td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={
                                                Spiritualcorner
                                              }
                                              alt="Heartfulness meditation"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Heartfulness meditation is a path
                                              of experiencing our inner Self. It
                                              teaches us to dive deep into our
                                              hearts and be in a natural state
                                              of love, peace, and calmness. When
                                              practiced regularly, meditation
                                              helps us to be in sync with our
                                              hearts and develop the capacity to
                                              remain poised and balanced at all
                                              times.
                                              <br />
                                              <br />
                                              At Comsense, we conduct regular
                                              Heartfulness meditation sessions
                                              and group meditations on Wednesday
                                              evenings. Everyone&apos;s
                                              experience in meditation is
                                              unique. Here in this video,
                                              Heartfulness practitioners
                                              worldwide share their thoughts on
                                              what they feel during meditation.
                                              <br />
                                              <br />
                                              Watch and witness the beautiful
                                              impact of daily meditation{" "}
                                              <a
                                                href="https://www.youtube.com/watch?v=E8EJhlzZ1ao"
                                                style={{
                                                  color: "#ff0000",
                                                  textDecoration: "none",
                                                  fontWeight: 500,
                                                }}
                                                target="_blank"
                                                rel="noreferrer noopener"
                                              >
                                                here &rsaquo;
                                              </a>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

          <table
            className="full"
            bgcolor="#333742"
            align="center"
            width="100%"
            border={0}
            cellSpacing={0}
            cellPadding={0}
          >
            <tbody>
              <tr>
                <td align="center">
                  <table
                    className="table-full"
                    width={600}
                    style={{ maxWidth: 600 }}
                    border={0}
                    align="center"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <tbody>
                      <tr>
                        <td
                          align="center"
                          background={city}
                          bgcolor="#515663"
                          style={{
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                          }}
                        >
                          <table
                            align="center"
                            width="95%"
                            border={0}
                            cellSpacing={0}
                            cellPadding={0}
                          >
                            <tbody>
                              <tr>
                                <td height={20} />
                              </tr>
                              <tr>
                                <td
                                  align="center"
                                  style={{
                                    fontFamily:
                                      "Century gothic,arial,sans-serif",
                                    fontSize: 22,
                                    fontWeight: 600,
                                    lineHeight: "30px",
                                    color: "#fff",
                                    letterSpacing: 1,
                                  }}
                                >
                                  Thanks for reading.
                                  <br />
                                  <span
                                    style={{
                                      fontFamily:
                                        "Century gothic,arial,sans-serif",
                                      fontSize: 14,
                                      fontWeight: 400,
                                      color: "#fff",
                                      letterSpacing: 1,
                                    }}
                                  >
                                    Did someone share this with you?{" "}
                                    <a
                                      style={{ color: "#fff" }}
                                      href="https://www.comsenseconsulting.com/newsletter/subscribe.html"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <u>Sign up</u>
                                    </a>{" "}
                                    here.
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td height={15} />
                              </tr>
                              <tr>
                                <td align="center">
                                  <table
                                    align="center"
                                    border={0}
                                    cellSpacing={0}
                                    cellPadding={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          bgcolor="#FF0000"
                                          height={40}
                                          style={{
                                            fontFamily:
                                              "Century Gothic,sans-serif",
                                            fontSize: 14,
                                            color: "#4a4a4a",
                                            fontWeight: 700,
                                            paddingLeft: 15,
                                            paddingRight: 16,
                                            letterSpacing: "1.5px",
                                          }}
                                        >
                                          <a
                                            href="https://www.comsensetechnologies.com/newsletter/subscribe.html"
                                            style={{
                                              textDecoration: "none",
                                              color: "#fff",
                                              borderRadius: 5,
                                            }}
                                            target="_blank" rel="noreferrer"
                                          >
                                            SUBSCRIBE
                                          </a>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    fontFamily:
                                      "Century gothic,arial,sans-serif",
                                    fontSize: 11,
                                    fontWeight: 400,
                                    color: "#fff",
                                    letterSpacing: 1,
                                    textAlign: "center",
                                  }}
                                >
                                  <br />
                                  If you liked this Newsletter, please recommend
                                  it to someone you know.
                                  <br />
                                  Or why not even share it on Twitter or
                                  Linkedin? … enough right?
                                  <br />
                                  If you don’t want to receive future
                                  Newsletters, please click here to{" "}
                                  <a
                                    style={{ color: "#fff" }}
                                    href="https://www.comsensetechnologies.com/newsletter/unsubscribe.html"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <u>unsubscribe</u>
                                  </a>
                                  .<br />
                                  We will miss you!
                                  <br />
                                  <br />
                                </td>
                              </tr>
                              <tr>
                                <td height={20} />
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </repeater>
        <table
          className="full"
          bgcolor="#333742"
          align="center"
          width="100%"
          border={0}
          cellSpacing={0}
          cellPadding={0}
        >
          <tbody>
            <tr>
              <td align="center">
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td bgcolor="#FFFFFF" align="center">
                        <table
                          className="table-inner"
                          width={550}
                          style={{ maxWidth: 550 }}
                          border={0}
                          align="center"
                          cellPadding={0}
                          cellSpacing={0}
                        >
                          <tbody>
                            <tr>
                              <td height={25} />
                            </tr>
                            <tr>
                              <td
                                align="center"
                                style={{
                                  fontFamily: '"Open sans",Arial,sans-serif',
                                  color: "#4a4a4a",
                                  fontSize: 16,
                                }}
                              >
                                FOLLOW US
                              </td>
                            </tr>
                            <tr>
                              <td height={25} />
                            </tr>
                            <tr>
                              <td>
                                <table
                                  className="table-full"
                                  border={0}
                                  align="center"
                                  cellPadding={0}
                                  cellSpacing={0}
                                >
                                  <tbody>
                                    <tr>
                                      <td>
                                        <table
                                          border={0}
                                          align="center"
                                          cellPadding={0}
                                          cellSpacing={0}
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="https://www.facebook.com/Comsenseconsulting/"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={fb1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-1"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                                target="_blank"
                                              >
                                                <a href="https://twitter.com/ComsenseTech">
                                                  <img
                                                    src={tw1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-2"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="http://linkedin.com/company/comsense-consulting"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={ln1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-3"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="https://www.instagram.com/comsensemktg/"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={ig1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-4"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="https://www.youtube.com/channel/UCCekynsEDZS7VORzB5KwX9g"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={yt1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-5"
                                                  />
                                                </a>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <tr>
                              <td height={25} />
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td height={5} bgcolor="#FF0000" />
                    </tr>
                  </tbody>
                </table>
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td height={25} />
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </>
    </>
  );
};

export default July2023;
